import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import StoreProfileForm from "./StoreProfileForm";

export default function ProfileModal({ isOpen, toggle }) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>Profile</ModalHeader>
      <ModalBody>
        <div className="text-muted small mb-3">
          Manage your account and billing details
        </div>
        <StoreProfileForm layout="modal" />
      </ModalBody>
    </Modal>
  );
}
